module.exports = __webpack_public_path__ + "static/media/afpColor.f435957f.svg";